import { useEffect, useRef } from 'react';
/**
 * Caches the passed in value and return the previous cached value. Returns
 * undefined on first call.
 */
export function usePrevious(value, defaultValue) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current ?? defaultValue;
}
